import { createContext } from 'react';
const RADIO_GROUP_CONTEXT_DEFAULT_VALUE = [
    {},
    () => null,
];
export const RadioGroupContext = createContext(RADIO_GROUP_CONTEXT_DEFAULT_VALUE);
